import React, { useEffect, useState } from 'react'

import { Alert } from '@frame/ui-primitives/alert'

import { useFileUploadContext } from '@documents/contexts/file-upload-context'
import { Transition } from '@headlessui/react'

export function FileErrors() {
  const { errors, clearErrors } = useFileUploadContext()
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (errors.length > 0) {
      setShow(true)
      const timer = setTimeout(() => {
        setShow(false)
        clearErrors()
      }, 3000)

      return () => {
        clearTimeout(timer)
        clearErrors()
      }
    }
  }, [errors, clearErrors])

  return (
    <Transition
      as="div"
      show={errors.length > 0 && show}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-out duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      className="absolute left-5 top-7 z-10 w-[calc(100%-48px)]"
    >
      <Alert variant="error" onClick={() => setShow(false)}>
        {errors.length > 1 ? (
          <ul className="ml-2 mt-1 list-inside list-disc">
            {errors.map((e) => (
              <li key={`${e.code}-${e.message}`}>
                {e.message} {e.fileName && `- ${e.fileName}`}
              </li>
            ))}
          </ul>
        ) : (
          <span>
            {errors[0]?.message} {errors[0]?.fileName && `- ${errors[0].fileName}`}
          </span>
        )}
      </Alert>
    </Transition>
  )
}
